import {Component} from '@angular/core';
import {RouterService, Spinner} from '@npck/libs/commons';
import {DialogService} from '@npck/libs/ui-kit';
import {AuthHolderService, Role} from '../../domain/auth-holder.service';
import {LogoutService} from '../../domain/logout-service';
import {NotificationsService} from '../../domain/notifications.service';
import {PasswordExpiryStatusService} from '../../domain/password-expiry-status.service';
import {Path} from '../../path';
import {ChangePasswordDialogComponent} from './change-password/change-password-dialog.component';

@Component({
    templateUrl: 'main-layout.component.html',
    styleUrls: ['main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent {
    Path = Path;
    Spinner = Spinner;
    navLinks: NavLink[] = [
        {
            link: Path.ANALYTICS,
            label: 'i18n_af_menuAnalytics',
            icon: 'ic_menu_analytics',
            roles: ['npck-admin', 'finance-user'],
        },
        {
            link: Path.INCIDENTS,
            label: 'i18n_af_menuIncidents',
            icon: 'ic_menu_incidents',
            roles: [],
        },
        {
            link: Path.REFUNDS,
            label: 'i18n_af_menuRefunds',
            icon: 'ic_menu_refunds',
            roles: [],
            excludeRoles: ['mobile-operator-user'],
        },
        {
            link: Path.AF_CENTRE,
            label: 'i18n_af_menuAfCentre',
            icon: 'ic_menu_subjects',
            roles: [],
            excludeRoles: ['mobile-operator-user'],
        },
        {
            link: Path.SUBJECTS,
            label: 'i18n_af_menuSubjects',
            icon: 'ic_menu_subjects',
            roles: [],
        },
        {
            link: Path.KNOWLEDGE_BASE,
            label: 'i18n_af_menuKnowledgeBase',
            icon: 'ic_menu_knowledge_base',
            roles: [],
        },
    ];

    isDrawerOpen = true;
    notificationsCount = 0;

    constructor(
        public authHolderService: AuthHolderService,
        public logoutService: LogoutService,
        public notificationsService: NotificationsService,
        private routerService: RouterService,
        private dialogService: DialogService,
        private passwordExpiryStatusService: PasswordExpiryStatusService,
    ) {
        this.notificationsService.notificationsSubject.subscribe(count => this.notificationsCount = count);
    }

    get passwordExpiryDaysLeft(): number {
        return this.authHolderService.passwordExpiryDaysLeft;
    }

    get showPasswordExpiryWarning(): boolean {
        return this.passwordExpiryStatusService.isExpiring(this.passwordExpiryDaysLeft);
    }

    get isLastAllowedDay(): boolean {
        return this.passwordExpiryDaysLeft === this.passwordExpiryStatusService.lastAllowedDays;
    }

    openNotifications(): void {
        this.routerService.navigate(Path.NOTIFICATIONS);
    }

    openChangePasswordDialog(): void {
        this.dialogService.openCustomDialogFitContent(ChangePasswordDialogComponent);
    }

    hasExcludedRole(navLink: NavLink): boolean {
        return !!navLink.excludeRoles?.length && this.authHolderService.hasAccess(navLink.excludeRoles);
    }

}

interface NavLink {
    link?: Path;
    label: string;
    icon: string;
    badge?: number;
    roles: Role[];
    excludeRoles?: Role[];
}
